import { FC, useCallback, useMemo } from "react";
import styled from "styled-components";
import designImg from './images/design.png';
import artImg from './images/artImg.png';
import fashionImg from './images/fashion.png';
import educationImg from './images/education.png';
import startupsImg from './images/startups.png';
import designImgEn from './images/design_En.png';
import artImgEn from './images/artImgEn.png';
import fashionImgEn from './images/fashion_En.png';
import educationImgEn from './images/education_En.png';
import startupsImgEn from './images/startups_En.png';
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";

const IMAGES = {
    'edu_design': {
        en: designImgEn,
        ru: designImg,
    },
    'edu_fashion': {
        en: fashionImgEn,
        ru: fashionImg,
    },
    'edu_art': {
        en: artImgEn,
        ru: artImg,
    },
    'edu_education': {
        en: educationImgEn,
        ru: educationImg,
    },
    'edu_startups': {
        en: startupsImgEn,
        ru: startupsImg,
    },
}

const EmblemContainer = styled.div<{ hideCursor?: boolean }>`
    background: transparent;
    position: relative;
    flex-direction: column;
    align-items: center;
    cursor: ${({ hideCursor }) => hideCursor ? 'default' : 'pointer'};
    justify-content: center;
    user-select: none;
    border-radius: 8px;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 270px;
    height: 380px;
    max-height: 380px;
    max-width: 270px;
    margin-left: 24px;
    flex-shrink: 0;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .empty-holder {
      width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 24px;
    }

    @media (max-width: 992px) {
        margin-top: 0;
        margin-left: 24px;
        min-width: 166px;
        width: 166px;
        max-width: 166px;
        height: 235px;
        max-height: 235px;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;

        img {
            width: 166px;
            max-width: 166px;
            height: 235px;
            max-height: 235px;
        }
    }

    @media(max-width: 576px) {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }
`

export const InteractiveEmblem: FC<{
    currentTab: string
}> = ({
    currentTab,
}) => {
    const { i18n: { language }} = useTranslation()
    const imageUrl = useMemo(() => {
        //@ts-ignore
        return IMAGES[currentTab]?.[language]
      },[currentTab, language])

    const outerUrl = useMemo(() => {
        const startUrl = process.env;
        return currentTab === 'edu_design' ? 
        startUrl['REACT_APP_URL_DEZIIIGN'] : 
        currentTab ==='edu_art' ? `${startUrl['REACT_APP_URL_MEDIIIA_COM']}/art` : 
        currentTab === 'edu_fashion' ? startUrl['REACT_APP_URL_DEZIIIGN_FASHION'] : 
        currentTab ==='edu_education' ? 'https://education.mediiia.ru/' :
        currentTab === 'edu_startups' ? 'https://brnd.ru/?tab=startups' :
        startUrl['REACT_APP_URL_DEZIIIGN'] 
    } , [currentTab])

    const goTo = useCallback(() => {
        if (!outerUrl?.length) return;

        window.open(outerUrl)
    }, [outerUrl])

    return  (
        <EmblemContainer onClick={goTo} hideCursor={!outerUrl?.length}>
            <img src={imageUrl} alt={'image_loop'} />
        </EmblemContainer>
    );
};import { FC, useCallback, useMemo } from "react";
import styled from "styled-components";
import designImg from './images/design.png';
import artImg from './images/artImg.png';
import fashionImg from './images/fashion.png';
import educationImg from './images/education.png';
import startupsImg from './images/startups.png';
import designImgEn from './images/design_En.png';
import artImgEn from './images/artImgEn.png';
import fashionImgEn from './images/fashion_En.png';
import educationImgEn from './images/education_En.png';
import startupsImgEn from './images/startups_En.png';
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";

const IMAGES = {
    'edu_design': {
        en: designImgEn,
        ru: designImg,
    },
    'edu_fashion': {
        en: fashionImgEn,
        ru: fashionImg,
    },
    'edu_art': {
        en: artImgEn,
        ru: artImg,
    },
    'edu_education': {
        en: educationImgEn,
        ru: educationImg,
    },
    'edu_startups': {
        en: startupsImgEn,
        ru: startupsImg,
    },
}

const EmblemContainer = styled.div<{ hideCursor?: boolean }>`
    background: transparent;
    position: relative;
    flex-direction: column;
    align-items: center;
    cursor: ${({ hideCursor }) => hideCursor ? 'default' : 'pointer'};
    justify-content: center;
    user-select: none;
    border-radius: 8px;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 270px;
    height: 380px;
    max-height: 380px;
    max-width: 270px;
    margin-left: 24px;
    flex-shrink: 0;
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .empty-holder {
      width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
      margin-bottom: 24px;
    }

    @media (max-width: 992px) {
        margin-top: 0;
        margin-left: 24px;
        min-width: 166px;
        width: 166px;
        max-width: 166px;
        height: 235px;
        max-height: 235px;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;

        img {
            width: 166px;
            max-width: 166px;
            height: 235px;
            max-height: 235px;
        }
    }

    @media(max-width: 576px) {
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }
`

export const InteractiveEmblem: FC<{
    currentTab: string
}> = ({
    currentTab,
}) => {
    const { i18n: { language }} = useTranslation()
    const imageUrl = useMemo(() => {
        //@ts-ignore
        return IMAGES[currentTab]?.[language]
      },[currentTab, language])

    const outerUrl = useMemo(() => {
        const startUrl = process.env;
        return currentTab === 'edu_design' ? 
        startUrl['REACT_APP_URL_DEZIIIGN'] : 
        currentTab ==='edu_art' ? `${startUrl['REACT_APP_URL_MEDIIIA_COM']}/art` : 
        currentTab === 'edu_fashion' ? startUrl['REACT_APP_URL_DEZIIIGN_FASHION'] : 
        currentTab ==='edu_education' ? 'https://education.mediiia.ru/' :
        currentTab === 'edu_startups' ? 'https://brnd.ru/?tab=startups' :
        startUrl['REACT_APP_URL_DEZIIIGN'] 
    } , [currentTab])

    const goTo = useCallback(() => {
        if (!outerUrl?.length) return;

        window.open(outerUrl)
    }, [outerUrl])

    return  (
        <EmblemContainer onClick={goTo} hideCursor={!outerUrl?.length}>
            <img src={imageUrl} alt={'image_loop'} />
        </EmblemContainer>
    );
};